export default {
	choiceMitra: [],
	numChoiceMitra: 0
}